import React from "react";

export const ConfidentialityPersonalDataOptOut = () => {
  return (
    <div>
      <strong>Non, je ne souhaite pas recevoir</strong> ces communications et{" "}
      <strong>renonce à ces conseils et offres</strong>
    </div>
  );
};
